import React from "react";
import {
  Box,
  Text,
  Heading,
  HStack,
  IconButton,
  Badge,
  Flex,
  VStack,
} from "@chakra-ui/react";
import { FaCar, FaHeart, FaPen } from "react-icons/fa";
import Translate from "../../../components/LanguageTranslation/Translate";
import { useCurrency } from "../../CurrencyExchange/CurrencyContext";

const RentalCarCard = ({ rentalCar, manual, handleDelete, handleEdit }) => {
  const { convertCurrency, currency } = useCurrency();

  // Safely handle missing price data
  const priceAmount = rentalCar.price?.amount ?? 0;
  const priceCurrency = rentalCar.price?.currency ?? "USD";

  const convertedPrice = convertCurrency(priceAmount, priceCurrency);

  // Format ISO date to readable
  const formatDate = (iso) => (iso ? new Date(iso).toLocaleDateString() : "—");

  return (
    <Box
      borderWidth="1px"
      borderRadius="lg"
      overflow="hidden"
      cursor="pointer"
      p={2}
    >
      <VStack
        p={2}
        borderRadius="xl"
        alignItems="flex-start"
        w="100%"
        spacing={3}
        bg="white"
        h="100%"
      >
        {/* Price and Company Info */}
        <Box width="100%" position="relative">
          <HStack spacing={1}>
            <FaCar size={40} style={{ marginRight: 16 }} />
            <Heading size="sm" mb={0} mr={2} noOfLines={1}>
              <Translate text={rentalCar.company || "Rental Company"} />
            </Heading>
            <IconButton
              aria-label="Edit rental car"
              icon={<FaPen />}
              size="sm"
              bg="none"
              _hover={{ bg: "gray.100" }}
              onClick={(e) => {
                e.stopPropagation();
                handleEdit(rentalCar);
              }}
            />
          </HStack>
          <Badge
            bg="none"
            color="#FFC719"
            border="1px solid"
            borderColor="#FFC719"
            borderRadius="md"
            textTransform="capitalize"
            fontSize="xs"
            fontWeight="bold"
            mb={2}
            mt={2}
          >
            <Translate text="Rental Car" />
          </Badge>
          <Text fontWeight="bold" fontSize="md" mt={2} mb={2}>
            <Translate text="Live price:" /> {currency} {convertedPrice}
          </Text>
          <IconButton
            aria-label="Add to favorites"
            icon={<FaHeart />}
            size="md"
            bg="none"
            _hover={{ bg: "none" }}
            position="absolute"
            top="0px"
            right="0px"
            borderRadius="full"
            color="red.500"
            onClick={handleDelete}
          />
        </Box>
        <HStack
          justify="space-between"
          width="full"
          spacing={0}
          bg="blackAlpha.50"
          padding={2}
          borderRadius="xl"
        >
          <Flex
            justify="space-between"
            mt={2}
            mb={2}
            width="100%"
            align="center"
          >
            <Text fontSize="sm" mb={0}>
              {rentalCar.pickupLocation}
            </Text>
            <Text fontSize="lg" mx={2} mb={0}>
              ➔
            </Text>
            <Text fontSize="sm" mb={0}>
              {rentalCar.dropoffLocation}
            </Text>
          </Flex>
        </HStack>
        <Flex justify="space-between" mb={2} width="100%">
          <Text fontSize="sm">
            <Translate text="Pickup:" /> {formatDate(rentalCar.pickupDate)}
          </Text>
          <Text fontSize="sm">
            <Translate text="Drop-off:" /> {formatDate(rentalCar.dropoffDate)}
          </Text>
        </Flex>
      </VStack>
    </Box>
  );
};

export default RentalCarCard;
